import type {MeasurementSeriesRange} from '../application/ports/body-measurements.repository';
import type {BodyMetricId} from '../domain/body-metric-id.value-object';

export const keys = {
  all: ['body-measurements'] as const,
  metrics: () => [...keys.all, 'metrics'] as const,
  overview: () => [...keys.all, 'overview'] as const,
  /** Prefix for every session-by-date query. */
  sessionAll: () => [...keys.all, 'session'] as const,
  session: (measuredOn: string) => [...keys.sessionAll(), measuredOn] as const,
  /** Prefix for every series query (any metric, any range). */
  seriesAll: () => [...keys.all, 'series'] as const,
  seriesForMetric: (metricId: BodyMetricId) => [...keys.seriesAll(), metricId] as const,
  series: (metricId: BodyMetricId, range: MeasurementSeriesRange) =>
    [...keys.seriesForMetric(metricId), range.from, range.to] as const,
  mutations: {
    createMetric: () => [...keys.all, 'mutations', 'create-metric'] as const,
    updateMetric: () => [...keys.all, 'mutations', 'update-metric'] as const,
    deleteMetric: () => [...keys.all, 'mutations', 'delete-metric'] as const,
    saveSession: () => [...keys.all, 'mutations', 'save-session'] as const,
    updateEntry: () => [...keys.all, 'mutations', 'update-entry'] as const,
    deleteEntry: () => [...keys.all, 'mutations', 'delete-entry'] as const,
  },
} as const;
